export const SUPPORT_CONTACT = {
  email: "support@universemoney.io",
  telephone: "01628 272056",
  telephoneHours: "Mon - Fri, 9am - 5pm",
} as const;
